import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m3 11 18-5v12L3 14v-3z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Megaphone";
const Megaphone = memo(themed(Icon));
export {
  Megaphone
};
//# sourceMappingURL=megaphone.js.map
